import React from 'react';
import { useTranslation } from 'react-i18next';

const SizeGuidePage = () => {
  const { t } = useTranslation();
  const mensShirts = [
    { size: 'XS', chest: '34-36', waist: '28-30', hips: '34-36' },
    { size: 'S', chest: '36-38', waist: '30-32', hips: '36-38' },
    { size: 'M', chest: '38-40', waist: '32-34', hips: '38-40' },
    { size: 'L', chest: '40-42', waist: '34-36', hips: '40-42' },
    { size: 'XL', chest: '42-44', waist: '36-38', hips: '42-44' },
    { size: '2XL', chest: '44-46', waist: '38-40', hips: '44-46' },
  ];

  const womensTops = [
    { size: 'XS', chest: '32-34', waist: '24-26', hips: '34-36' },
    { size: 'S', chest: '34-36', waist: '26-28', hips: '36-38' },
    { size: 'M', chest: '36-38', waist: '28-30', hips: '38-40' },
    { size: 'L', chest: '38-40', waist: '30-32', hips: '40-42' },
    { size: 'XL', chest: '40-42', waist: '32-34', hips: '42-44' },
    { size: '2XL', chest: '42-44', waist: '34-36', hips: '44-46' },
  ];

  return (
    <div className="min-h-screen bg-white py-16">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-serif text-[#2C2420] mb-4">{t('sizeGuide.title')}</h1>
          <p className="text-gray-600">
            {t('sizeGuide.subtitle')}
          </p>
        </div>

        {/* How to Measure */}
        <div className="bg-[#FAF8F5] p-8 rounded-lg mb-12">
          <h2 className="text-2xl font-serif text-[#2C2420] mb-6">{t('sizeGuide.howToMeasure')}</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div>
              <h3 className="font-semibold text-[#2C2420] mb-2">{t('sizeGuide.chest')}</h3>
              <p className="text-sm text-gray-600">
                {t('sizeGuide.chestDesc')}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-[#2C2420] mb-2">{t('sizeGuide.waist')}</h3>
              <p className="text-sm text-gray-600">
                {t('sizeGuide.waistDesc')}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-[#2C2420] mb-2">{t('sizeGuide.hips')}</h3>
              <p className="text-sm text-gray-600">
                {t('sizeGuide.hipsDesc')}
              </p>
            </div>
          </div>
        </div>

        {/* Men's Sizing */}
        <div className="mb-12">
          <h2 className="text-2xl font-serif text-[#2C2420] mb-6">{t('sizeGuide.mensSizing')}</h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-[#2C2420] text-white">
                  <th className="p-4 text-left">{t('sizeGuide.size')}</th>
                  <th className="p-4 text-left">{t('sizeGuide.chestInches')}</th>
                  <th className="p-4 text-left">{t('sizeGuide.waistInches')}</th>
                  <th className="p-4 text-left">{t('sizeGuide.hipsInches')}</th>
                </tr>
              </thead>
              <tbody>
                {mensShirts.map((size, idx) => (
                  <tr key={idx} className={idx % 2 === 0 ? 'bg-[#FAF8F5]' : 'bg-white'}>
                    <td className="p-4 font-semibold">{size.size}</td>
                    <td className="p-4">{size.chest}</td>
                    <td className="p-4">{size.waist}</td>
                    <td className="p-4">{size.hips}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Women's Sizing */}
        <div className="mb-12">
          <h2 className="text-2xl font-serif text-[#2C2420] mb-6">{t('sizeGuide.womensSizing')}</h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-[#2C2420] text-white">
                  <th className="p-4 text-left">{t('sizeGuide.size')}</th>
                  <th className="p-4 text-left">{t('sizeGuide.chestInches')}</th>
                  <th className="p-4 text-left">{t('sizeGuide.waistInches')}</th>
                  <th className="p-4 text-left">{t('sizeGuide.hipsInches')}</th>
                </tr>
              </thead>
              <tbody>
                {womensTops.map((size, idx) => (
                  <tr key={idx} className={idx % 2 === 0 ? 'bg-[#FAF8F5]' : 'bg-white'}>
                    <td className="p-4 font-semibold">{size.size}</td>
                    <td className="p-4">{size.chest}</td>
                    <td className="p-4">{size.waist}</td>
                    <td className="p-4">{size.hips}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Fit Guide */}
        <div className="bg-[#FAF8F5] p-8 rounded-lg">
          <h2 className="text-2xl font-serif text-[#2C2420] mb-6">{t('sizeGuide.fitGuide')}</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-semibold text-[#2C2420] mb-2">{t('sizeGuide.regularFit')}</h3>
              <p className="text-sm text-gray-600">
                {t('sizeGuide.regularFitDesc')}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-[#2C2420] mb-2">{t('sizeGuide.slimFit')}</h3>
              <p className="text-sm text-gray-600">
                {t('sizeGuide.slimFitDesc')}
              </p>
            </div>
          </div>

          <div className="mt-6 p-4 bg-white rounded border-l-4 border-[#be1f1a]">
            <p className="text-sm text-gray-600">
              <strong>{t('sizeGuide.needHelp')}</strong> {t('sizeGuide.needHelpText')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeGuidePage;